import { render, staticRenderFns } from "./BlockHeader.vue?vue&type=template&id=09506f9d&scoped=true"
import script from "./BlockHeader.vue?vue&type=script&lang=js"
export * from "./BlockHeader.vue?vue&type=script&lang=js"
import style0 from "./BlockHeader.vue?vue&type=style&index=0&id=09506f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09506f9d",
  null
  
)

export default component.exports